/* eslint-disable class-methods-use-this */
class Storage {
  public set(name: string, value: {} | string) {
    const val = typeof value === 'object' ? JSON.stringify(value) : String(value);
    window.localStorage.setItem(name, val);
  }

  public get(key: string): string | null {
    const result = window.localStorage.getItem(key);
    return result === undefined || result === null ? null : result;
  }

  public remove(name: string) {
    window.localStorage.removeItem(name);
  }
}

export default new Storage();
